import { render, staticRenderFns } from "./Vendors.vue?vue&type=template&id=b4adc6ee&scoped=true"
import script from "./Vendors.vue?vue&type=script&lang=js"
export * from "./Vendors.vue?vue&type=script&lang=js"
import style0 from "./Vendors.vue?vue&type=style&index=0&id=b4adc6ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4adc6ee",
  null
  
)

export default component.exports